import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button } from "antd";
import {
  HomeOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  IdcardOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  ScanOutlined,
  BankOutlined,
  SafetyOutlined,
  ApartmentOutlined,
  CheckSquareOutlined,
  FileProtectOutlined,
  DollarOutlined,
  FileTextOutlined,
  FileAddOutlined,
  EditOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  AuditOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  LineChartOutlined,
  BarChartOutlined,
  PieChartOutlined,
  FundOutlined,
  NotificationOutlined,
  ReadOutlined,
  FileDoneOutlined,
  ExportOutlined,
  AlertOutlined,
  RiseOutlined,
  SolutionOutlined,
  MenuOutlined,
  FormOutlined
} from "@ant-design/icons";


import TeamAssessment from "../../TeamAssessment";
import PipApprovals from "../../PipApprovals";

import { AuthContext } from "../../../context/AuthContext";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import Footer from "../../../components/footer/Footer";

import CreateMrfHr from "../createmrfhr/CreateMrfHr";
import ViewRequisitions from "../viewrequisitions/ViewRequisitions";
import InterviewPage from "../../interviewpage/InterviewPage";
import HrArea from "../../announcement/hrarea/HrArea";
import HrViewAnnouncement from "../hrviewannouncement/HrViewAnnouncement";
import VerifiedCandidates from "../verifiedcandidates/VerifiedCandidates";
import AddHoliday from "../AddHoliday";
import ViewEmployees from "../../ViewEmployees";
import ApproveVenue from "../ApproveVenue";
import ViewEmployeeAttendance from "../ViewEmployeeAttendance";
import FingerHeadOffice from "../FingerPrintHead";
import AttendanceHead from "../AttendanceHead";
import FingerprintSite from "../FingerPrintSite";
import AttendanceSite from "../AttendanceSite";
import Leaves from "../../../components/employee/Leaves";
import Permission from "../../../components/employee/Permission";
import OffDay from "../../../components/employee/OffDay";
import Holidays from "../../employee/Holidays";
import EmpLeaves from "../EmpLeaves";
import EmpPermissions from "../EmpPermissions";
import EmpCompoff from "../EmpCompoff";
import Rfc from "../../../components/Rfc";
import SalaryDetails from "../SalaryDetails";
import HrIndex from "../HrIndex";
import OtApprovals from "../../../components/OtApprovals";
import ListTickets from "../../../components/ListTickets";
import ResignationRequests from "../../ResignationRequests";
import FinalSettlement from "../../payroll/FinalSettlement";
import EmployeeAttendanceReport from "../../../components/HrReports/EmployeeAttendanceReport";
import LeaveUtilizationReport from "../../../components/HrReports/LeaveUtilizationReport";
import EmployeeIdCards from "../EmployeeIdCards";
import DepartmentWisePayroll from "../../../components/HrReports/DepartmentWisePayroll";
import FixedSalary from "../FixedSalary";
import ProbationReview from "../../../components/employee/ProbationReview";
import OtReport from "../reports/OtReport";
import LeaveReport from "../reports/LeaveReport";
import CompoffReport from "../reports/CompoffReport";
import LateEarlyReport from "../reports/LateEarlyReport";
import OndutyReport from "../reports/OndutyReport";
import IdCardReport from "../reports/IdCardReport";
import CugReport from "../reports/CugReport";
import CheckListReport from "../reports/CheckListReport";
import SecondCheckList from "../reports/SecondCheckList";
import GrossSalary from "../reports/GrossSalary";
import ListNoc from "../../ListNoc"
import ExitInterview from "../../ExitInterview";
import PersmissionRequests from "../PermissionRequests";
import ShowSpecialPermission from "../../ShowSpecialPermission";
import ApproveTI from "../ApproveTI";
import RfcHr from "../RfcHr";
import PastOnduty from "../../employee/PastOnduty";
import ProbationReviewHr from "../ProbationReviewHr";
import StatusUpdation from "../StatusUpdation";
import ViewImproperHr from "../ViewImproperHr";


const { Sider, Content } = Layout;
const { Text } = Typography;

export default function HrDashboard() {
  // const { authData } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("hrDashboardPage") || "home";
  });

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    localStorage.setItem("hrDashboardPage", selectedMenu);
  }, [selectedMenu]);

  const menuItems = [
    { key: "home", icon: <HomeOutlined />, label: "Dashboard" },

    {
      key: "employee",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        { key: "verifiedcandidates", icon: <CheckSquareOutlined />, label: "Candidate Verification" },
        { key: "viewEmployees", icon: <TeamOutlined />, label: "View Employees" },
        { key: "idcard", icon: <IdcardOutlined />, label: "Employee ID Cards" },
      ],
    },
    {
      key: "onduty",
      icon: <CheckSquareOutlined />,
      label: "Onduty Requests",
    },
    {
      key: "improperApproval",
      icon: <CheckSquareOutlined />,
      label: "Inproper Attendance",
    },
    {
      key: "attendance",
      icon: <ClockCircleOutlined />,
      label: "Attendance",
      children: [
        { key: "viewEmployeeRecords", icon: <FileSearchOutlined />, label: "Check-In & Check-Out" },
        { key: "fingerHeadOffice", icon: <ScanOutlined />, label: "Fingerprint – Head Office" },
        { key: "attendanceHeadOffice", icon: <BankOutlined />, label: "Attendance – Head Office" },
        { key: "fingerSiteOffice", icon: <SafetyOutlined />, label: "Fingerprint – Site Office" },
        { key: "attendanceSiteOffice", icon: <HomeOutlined />, label: "Attendance – Site Office" },

        {
          key: "generalpermisssion",
          icon: <ApartmentOutlined />,
          label: "General Permission",
          children: [
            {
              key: "permissionRequests",
              icon: <CheckSquareOutlined />,
              label: "Approve Permission Requests",
            },
          ],
        },

        { key: "rfc", icon: <FileProtectOutlined />, label: "Permission Considerations" },
        { key: "approvals", icon: <CheckSquareOutlined />, label: "Status Updation Approvals" }
      ],
    },

    {
      key: "payroll",
      icon: <DollarOutlined />,
      label: "Payroll",
      children: [
        { key: "viewsalary", icon: <FileTextOutlined />, label: "Actual Salary" },
        { key: "salarydetails", icon: <CalendarOutlined />, label: "Monthly Salary Statement" },
      ],
    },

    {
      key: "recruitement",
      icon: <SolutionOutlined />,
      label: "Recruitment",
      children: [
        {
          key: "mrf",
          icon: <FileAddOutlined />,
          label: "MRF",
          children: [
            { key: "applyMRF", icon: <EditOutlined />, label: "Apply MRF" },
            { key: "viewRequisitions", icon: <FileTextOutlined />, label: "View Requisitions" },
          ],
        },
      ],
    },

    {
      key: "exitmanagement",
      icon: <LogoutOutlined />,
      label: "Exit Management",
      children: [
        { key: "resignedEmployees", icon: <UserDeleteOutlined />, label: "Resigned Employees" },
        { key: "resignationRequests", icon: <FileTextOutlined />, label: "Resignation Requests" },
        { key: "hrfinalstatement", icon: <AuditOutlined />, label: "Final Settlement Approvals" },
      ],
    },

    { key: "venue", icon: <EnvironmentOutlined />, label: "Venues" },

    { key: "holidaylist", icon: <CalendarOutlined />, label: "Holiday List" },

    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        { key: "employeeattendance", icon: <CalendarOutlined />, label: "Employee Attendance Report" },
        { key: "leaveutilization", icon: <PieChartOutlined />, label: "Leave Utilization Report" },

        {
          key: "departmentwisepayroll",
          icon: <DollarOutlined />,
          label: "Payroll",
          children: [
            { key: "grossreport", icon: <FundOutlined />, label: "Gross Report" },
          ],
        },

        { key: "otReport", icon: <ClockCircleOutlined />, label: "OT Report" },
        { key: "leaveReport", icon: <FileDoneOutlined />, label: "Leave Report" },
        { key: "ondutyReport", icon: <ExportOutlined />, label: "On Duty Report" },
        { key: "compoffReport", icon: <AlertOutlined />, label: "Comp Off Report" },
        { key: "lateEarlyReport", icon: <AlertOutlined />, label: "Late In & Early Out Report" },
        { key: "IdCard", icon: <IdcardOutlined />, label: "ID Card Report" },
        { key: "CugReport", icon: <FileTextOutlined />, label: "CUG Report" },
        { key: "checklistreport", icon: <CheckSquareOutlined />, label: "Check List" },
        { key: "secondChecklist", icon: <CheckSquareOutlined />, label: "Check List 2" },
      ],
    },

    {
      key: "nocForms",
      icon: <FileProtectOutlined />,
      label: "NOC Forms",
    },

    {
      key: "announcement",
      icon: <NotificationOutlined />,
      label: "Announcement",
      children: [
        { key: "makeAnnouncement", icon: <EditOutlined />, label: "Make Announcement" },
        { key: "viewAnnouncement", icon: <ReadOutlined />, label: "View Announcements" },
      ],
    },

    {
      key: "leaves",
      icon: <CalendarOutlined />,
      label: "Leaves & Permissions",
      children: [
        { key: "empleaves", icon: <FileDoneOutlined />, label: "Leaves" },
        { key: "emppermissions", icon: <ExportOutlined />, label: "Permissions" },
        { key: "empcompoffs", icon: <AlertOutlined />, label: "Off Day Working" },
      ],
    },

    {
      key: "otapproval",
      icon: <ClockCircleOutlined />,
      label: "Over Time Requests",
    },

    {
      key: "viewAppraisals",
      icon: <RiseOutlined />,
      label: "View Appraisal Assessments",
    },

    {
      key: "tickets",
      icon: <AlertOutlined />,
      label: "Raised Tickets",
    },

    {
      key: "teamemployement",
      icon: <UserSwitchOutlined />,
      label: "Probation Employee",
    },

    {
      key: "pipapprovals",
      icon: <FileDoneOutlined />,
      label: "PIP Approvals",
    },
    { key: "show_special_permission", icon: <FormOutlined />, label: "Show General Permisssion" },
    { key: "approve_technical_issue", icon: <FormOutlined />, label: "Approve Techincal Issues" },
  ];


  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return (
          <>
            <HrIndex />
          </>
        );
      case "applyMRF":
        return <CreateMrfHr onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <ViewRequisitions />;
      case "interview":
        return <InterviewPage />;
      case "makeAnnouncement":
        return <HrArea />;
      case "viewAnnouncement":
        return <HrViewAnnouncement />;
      case "verifiedcandidates":
        return <VerifiedCandidates />;
      case "holidaylist":
        return <AddHoliday />;
      case "viewEmployees":
        return <ViewEmployees />;
      case "venue":
        return <ApproveVenue />;
      case "viewEmployeeRecords":
        return <ViewEmployeeAttendance />;
      case "fingerHeadOffice":
        return <FingerHeadOffice />;
      case "attendanceHeadOffice":
        return <AttendanceHead />;
      case "fingerSiteOffice":
        return <FingerprintSite />;
      case "attendanceSiteOffice":
        return <AttendanceSite />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "empleaves":
        return <EmpLeaves />
      case "emppermissions":
        return <EmpPermissions />
      case "empcompoffs":
        return <EmpCompoff />
      case "rfc":
        return <RfcHr />
      case "salarydetails":
        return <SalaryDetails />
      case "otapproval":
        return <OtApprovals />
      case "viewAppraisals":
        return <TeamAssessment />
      case "tickets":
        return <ListTickets />
      case "pipapprovals":
        return <PipApprovals />
      case "resignationRequests":
        return <ResignationRequests />
      case "hrfinalstatement":
        return <FinalSettlement />
      case "employeeattendance":
        return <EmployeeAttendanceReport />
      case "leaveutilization":
        return <LeaveUtilizationReport />
      case "idcard":
        return <EmployeeIdCards />
      case "departmentwisepayroll":
        return <DepartmentWisePayroll />
      case "viewsalary":
        return <FixedSalary />
      case "teamemployement":
        return <ProbationReviewHr />;
      case "otReport":
        return <OtReport />
      case "leaveReport":
        return <LeaveReport />
      case "compoffReport":
        return <CompoffReport />
      case "lateEarlyReport":
        return <LateEarlyReport />
      case "ondutyReport":
        return <OndutyReport />
      case "IdCard":
        return <IdCardReport />
      case "CugReport":
        return <CugReport />
      case "checklistreport":
        return <CheckListReport />
      case "secondChecklist":
        return <SecondCheckList />
      case "grossreport":
        return <GrossSalary />
      case "nocForms":
        return <ListNoc />
      case "resignedEmployees":
        return <ViewEmployees isResigned={true} />;
      case "permissionRequests":
        return <PersmissionRequests />
      case "show_special_permission":
        return <ShowSpecialPermission />
      case "approve_technical_issue":
        return <ApproveTI />
      case "onduty":
        return <PastOnduty />
      case "approvals":
        return <StatusUpdation />
      case "improperApproval":
        return <ViewImproperHr />
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />

      {/* Mobile top menu toggle */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ background: "#fff" }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={280}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
            }}
          >
            <style>{`
              .ant-menu { background: #fff !important; border-right: none !important; }
              .ant-menu-item, .ant-menu-submenu-title { font-weight: bold; color: #0e497b !important; transition: all 0.2s ease; }
              .ant-menu-item:hover, .ant-menu-submenu-title:hover { background-color: rgba(14,73,123,0.05) !important; color: #0e497b !important; }
              .ant-menu-item-selected { background-color: #0e497b !important; color: #fff !important; }
              .ant-menu-item-selected .anticon { color: #fff !important; }
              .ant-menu-submenu-open > .ant-menu-submenu-title { color: #0e497b !important; background-color: rgba(14,73,123,0.05) !important; }
            `}</style>

            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
              items={menuItems}
            />
          </Sider>
        )}

        {/* Mobile Drawer Sidebar */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
            items={menuItems}
          />
        </Drawer>

        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      {/* <Footer style={{ background: "#fff" }} /> */}
    </Layout>
  );
}
